// payments.service.ts
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import {
  CustomerPortalResponse,
  ModifySubscriptionAtPeriodEndResponse,
  SubscriptionData,
} from '../models/payments-model';

@Injectable({
  providedIn: 'root',
})
export class PaymentsService {
  private apiUrl = environment.apiUrl;

  constructor(private http: HttpClient) {}

  addHeader(): HttpHeaders {
    const token = sessionStorage.getItem('psicogeniusAccessToken');

    let headers = new HttpHeaders();
    if (token) {
      headers = headers.set('Authorization', `Bearer ${token}`);
    }
    return headers;
  }

  createCheckoutSession(): Observable<any> {
    const headers = this.addHeader();
    return this.http.post(
      `${this.apiUrl}/sub/create-checkout-session`,
      {},
      { headers }
    );
  }

  createCustomerPortalSession(): Observable<CustomerPortalResponse> {
    const headers = this.addHeader();
    return this.http.post<CustomerPortalResponse>(
      `${this.apiUrl}/sub/create-customer-portal-session`,
      {},
      { headers }
    );
  }

  getSubscriptionData(): Observable<SubscriptionData> {
    const headers = this.addHeader();
    return this.http.get<SubscriptionData>(
      `${this.apiUrl}/sub/subscription-data`,
      { headers }
    );
  }

  modifySubscription(
    cancelAtPeriodEnd: boolean
  ): Observable<ModifySubscriptionAtPeriodEndResponse> {
    const headers = this.addHeader();
    return this.http.patch<ModifySubscriptionAtPeriodEndResponse>(
      `${this.apiUrl}/sub/subscription`,
      { cancel_at_period_end: cancelAtPeriodEnd },
      { headers }
    );
  }
}
